module.exports = __webpack_public_path__ + "img/voice.ffc97829.svg";